import { defineStore } from 'pinia';
import { reactive } from 'vue';
import type { IMenuItem } from '~/types/site/menu';
import type { IMenuApiResponse } from '~/modules/menu/types/menu';
import type { ICategoryItem } from '~/modules/categories/types/categories';

/**
 * @deprecated
 */
export const useMenuStore = defineStore('useMenuStore', () => {
  const menuList = reactive<IMenuItem[]>([]);
  const menuHeadCategories = reactive<ICategoryItem[]>([]);

  const rewriteMenu = (data: IMenuApiResponse) => {
    menuList.splice(0, menuList.length, ...data.items);
  };

  const rewriteHeadCategories = (data: ICategoryItem[]) => {
    menuHeadCategories.splice(0, menuHeadCategories.length, ...data);
  };

  return {
    menuList,
    menuHeadCategories,
    rewriteMenu,
    rewriteHeadCategories,
  };
});
